import { Button, Grid2, Modal } from "@mui/material";
import React from "react";
import "./index.scss";
import { removeAccessTokenCookie, removeRefreshTokenCookie, removeRepTokenCookie } from "lib/Storage";
import { useNavigate } from "react-router-dom";

const CustomModalLogOut = ({ open, handleClose }) => {
  const navigate = useNavigate();

  const handleCloseModal = () => {
    handleClose(false);
  };
  const handleLogout = () => {
    navigate("/login");
    removeRefreshTokenCookie();
    removeAccessTokenCookie();
    removeRepTokenCookie();
    window.location.reload();
  };
  return (
    <Modal
      open={open}
      onClose={handleCloseModal}
      className="modal-box-container-logout"
    >
      <Grid2
        className="parent-content-modal-logout"
        container
        columns={12}
        dir="rtl"
      >
        <Grid2 className="top-text" item size={{ xs: 11 }}>
          آیا می خواهید از حساب کاربری خود خارج شوید؟
        </Grid2>

        <Grid2 className="box-button" item size={{ xs: 11 }}>
          <Button className="reject" onClick={handleCloseModal}>
            لغو
          </Button>
          <Button className="confirm" onClick={handleLogout}>
            تایید
          </Button>
        </Grid2>
      </Grid2>
    </Modal>
  );
};

export default CustomModalLogOut;
